var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.844,
    height: 47.442,
    viewBox: "0 0 39.844 47.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.826,
    cy: 7.826,
    r: 7.826,
    transform: "translate(53.227)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.775,181.515a10.634,10.634,0,0,1-11.575,0,16.2,16.2,0,0,0-5.039,3.078l10.826,4.06,10.826-4.06A16.2,16.2,0,0,0,155.775,181.515Z",
    transform: "translate(-89.065 -164.696)",
    fill: "#bbd861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.316,310h-.927a1.39,1.39,0,0,0-1.39,1.39V315.1a1.39,1.39,0,0,0,1.39,1.39h.927a3.243,3.243,0,0,0,0-6.486Z",
    transform: "translate(-335.715 -281.275)",
    fill: "#bbd861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,231.851a1.39,1.39,0,0,0-.6,1.142v3.094h.463a4.174,4.174,0,0,1,4.17,4.17v3.706a4.174,4.174,0,0,1-4.17,4.17H81v2.929a1.39,1.39,0,0,0,.9,1.3l13.924,5.221V236.548l-12.948-4.855A1.389,1.389,0,0,0,81.6,231.851Z",
    transform: "translate(-36.294 -210.143)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.193,243.964v-3.706a4.174,4.174,0,0,1,4.17-4.17h.463v-3.094a1.39,1.39,0,0,0-1.878-1.3L271,236.548v21.038l13.924-5.221a1.39,1.39,0,0,0,.9-1.3v-2.929h-.463A4.175,4.175,0,0,1,281.193,243.964Z",
    transform: "translate(-208.688 -210.143)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,315.1V311.39A1.39,1.39,0,0,0,45.17,310h-.927a3.243,3.243,0,0,0,0,6.486h.927A1.39,1.39,0,0,0,46.56,315.1Z",
    transform: "translate(0 -281.275)",
    fill: "#bbd861"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.1f4a487604ea8a7ea4c6d57597766cc2.svg";
export { ForwardRef as ReactComponent };